module.exports = __webpack_public_path__ + "img/participant-list-mobile-ru.c6eda87a.jpg";